import { getRoomCapicityLabel } from "../../../../constants/constent";
import assets from "../../../../utils/ImagesPath";

const ServiceList = ({ room_type, occupancy }) => {
  // Room service label mapping
  // const roomServiceMapping = {
  //   cp: "Breakfast",
  //   map: "Breakfast, Lunch or dinner",
  //   ap: "Breakfast, Lunch & Dinner",
  // };

  // // Image mapping for room service
  // const imageMapping = {
  //   cp: assets.breakfast,
  //   map: assets.lunch,
  //   ap: assets.dinner,
  // };

  const roomTypeValue = getRoomCapicityLabel(room_type) || room_type;
  // const roomServiceLabel = roomServiceMapping[ota_room_service];
  // const imageSrc = imageMapping[ota_room_service] || "default_image.png";

  return (
    <div
      className="service-display hide-on-mobile"
      style={{ display: "flex", alignItems: "center", gap: "8px" }}
    >
      <img style={{ width: "14px" }} src={assets.user} alt="Room Type" />
      <span style={{ textAlign: "center" }}>{occupancy}</span>

      {/* {roomServiceLabel && (
        <>
          <span style={{ textAlign: "center" }}>|</span>
          <img
            style={{ width: "25px" }}
            src={imageSrc}
            alt={ota_room_service}
          />
          <span style={{ textAlign: "center" }}>{roomServiceLabel}</span>
        </>
      )} */}
    </div>
  );
};

export default ServiceList;
